// 门店数据
export const stores = [
  { id: 1, name: '总店', address: '北京市朝阳区建国路88号' },
  { id: 2, name: '分店1', address: '上海市浦东新区陆家嘴金融中心' },
  { id: 3, name: '分店2', address: '广州市天河区珠江新城' },
];

// 员工数据
export const staffs = [
  { id: 1, name: '张总', phone: '13800138001', storeId: 1, role: 'boss' },
  { id: 2, name: '李店长', phone: '13800138002', storeId: 1, role: 'manager' },
  { id: 3, name: '王店长', phone: '13800138003', storeId: 2, role: 'manager' },
  { id: 4, name: '赵店长', phone: '13800138004', storeId: 3, role: 'manager' },
  { id: 5, name: '刘顾问', phone: '13800138005', storeId: 1, role: 'staff' },
  { id: 6, name: '陈顾问', phone: '13800138006', storeId: 2, role: 'staff' },
  { id: 7, name: '吴顾问', phone: '13800138007', storeId: 3, role: 'staff' },
];

// 会员数据
export const members = [
  {
    id: 1,
    name: '马先生',
    gender: '男',
    age: 35,
    phone: '13900139001',
    address: '北京市海淀区中关村',
    coupleId: 2,
    category: 'A',
    storeId: 1,
    staffId: 5,
    points: 1200
  },
  {
    id: 2,
    name: '马女士',
    gender: '女',
    age: 32,
    phone: '13900139002',
    address: '北京市海淀区中关村',
    coupleId: 1,
    category: 'A',
    storeId: 1,
    staffId: 5,
    points: 1500
  },
  {
    id: 3,
    name: '王先生',
    gender: '男',
    age: 45,
    phone: '13900139003',
    address: '上海市徐汇区',
    coupleId: 4,
    category: 'S',
    storeId: 2,
    staffId: 6,
    points: 5000
  },
  {
    id: 4,
    name: '王女士',
    gender: '女',
    age: 42,
    phone: '13900139004',
    address: '上海市徐汇区',
    coupleId: 3,
    category: 'S',
    storeId: 2,
    staffId: 6,
    points: 4800
  },
  {
    id: 5,
    name: '李小姐',
    gender: '女',
    age: 28,
    phone: '13900139005',
    address: '广州市番禺区',
    coupleId: null,
    category: 'B',
    storeId: 3,
    staffId: 7,
    points: 800
  },
  {
    id: 6,
    name: '张先生',
    gender: '男',
    age: 55,
    phone: '13900139006',
    address: '北京市朝阳区',
    coupleId: null,
    category: 'A',
    storeId: 1,
    staffId: 5,
    points: 2000
  },
];

// 类别选项
export const categoryOptions = [
  { label: 'S级会员', value: 'S' },
  { label: 'A级会员', value: 'A' },
  { label: 'B级会员', value: 'B' },
  { label: 'C级会员', value: 'C' },
];

// 获取会员的门店名称
export const getMemberStoreName = (memberId) => {
  const member = members.find(m => m.id === memberId);
  if (!member) return '';
  const store = stores.find(s => s.id === member.storeId);
  return store ? store.name : '';
};

// 获取会员的员工名称
export const getMemberStaffName = (memberId) => {
  const member = members.find(m => m.id === memberId);
  if (!member) return '';
  const staff = staffs.find(s => s.id === member.staffId);
  return staff ? staff.name : '';
};

// 根据用户角色获取可见的会员列表
export const getVisibleMembers = (user) => {
  if (!user) return [];
  if (user.role === 'boss') {
    return [...members]; // 老板可以看所有会员
  } else if (user.role === 'manager') {
    return members.filter(m => m.storeId === user.storeId); // 店长只能看自己门店的会员
  } else if (user.role === 'staff') {
    return members.filter(m => m.staffId === user.id); // 员工只能看自己服务的会员
  }
  return [];
};

// 获取会员夫妻标签
export const getCoupleTag = (memberId) => {
  const member = members.find(m => m.id === memberId);
  if (!member || !member.coupleId) return null;
  return '夫妻';
};

// 模拟登录用户数据
export const users = [
  { username: 'boss', password: '123456', ...staffs.find(s => s.role === 'boss') },
  { username: 'manager1', password: '123456', ...staffs.find(s => s.id === 2) },
  { username: 'manager2', password: '123456', ...staffs.find(s => s.id === 3) },
  { username: 'manager3', password: '123456', ...staffs.find(s => s.id === 4) },
  { username: 'staff1', password: '123456', ...staffs.find(s => s.id === 5) },
  { username: 'staff2', password: '123456', ...staffs.find(s => s.id === 6) },
  { username: 'staff3', password: '123456', ...staffs.find(s => s.id === 7) },
]; 